export class ApplicationRole {
    
    constructor(public id: number, public name: string) {}

}